import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import { useLayoutContext } from 'common/bento/lib/layout';
import useOnHistoryPop from 'common/bento/lib/useOnHistoryPop';
import useScrollToTopOnMount from 'common/hooks/useScrollToTopOnMount';
import LegacyPageProps from 'features/Onboarding/legacy/Pages/PageProps';

import OBNavigation from './OBNavigation/OBNavigation';

interface OnboardingPageAdapterProps extends LegacyPageProps {
  onPrev: () => void;
  LegacyOnboardingPage: FC<LegacyPageProps>;
}

const OnboardingPageAdapter = ({
  LegacyOnboardingPage,
  onPrev,
  ...props
}: OnboardingPageAdapterProps) => {
  useOnHistoryPop(onPrev);

  const { Layout } = useLayoutContext();

  useScrollToTopOnMount();

  return (
    <Box height="full">
      <Layout
        /**
         * Passing info to the parent Layout without updating its API.
         * Legacy pages are so much different that we have to treat them differently.
         * Eg. they include the back button although they shouldn't.
         */
        data-onboarding-legacy
        nav={<OBNavigation />}
      >
        <LegacyOnboardingPage {...props} />
      </Layout>
    </Box>
  );
};

export default OnboardingPageAdapter;
